import {Plugins} from '@packages/systems/wfdl';

export const pluginName = Plugins.name('DynamoGateway');
